var _style, _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBellActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26.06 28.67",
    style: {
      enableBackground: "new 0 0 26.06 28.67"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:#009698;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.12,26.33c0.94,0.83,2.18,1.33,3.53,1.33s2.59-0.5,3.53-1.33 M20.65,9c0-2.12-0.84-4.16-2.34-5.66 S14.77,1,12.65,1S8.5,1.84,7,3.34C5.49,4.84,4.65,6.88,4.65,9c0,4.12-1.04,6.94-2.2,8.81C1.47,19.38,0.98,20.17,1,20.39 c0.02,0.24,0.07,0.34,0.27,0.48C1.44,21,2.24,21,3.84,21h17.63c1.6,0,2.39,0,2.57-0.13c0.2-0.15,0.25-0.24,0.27-0.48 c0.02-0.22-0.47-1.01-1.45-2.58C21.69,15.94,20.65,13.12,20.65,9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 19.56,
    cy: 7.2,
    r: 5.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellActive);
export default __webpack_public_path__ + "static/media/bell-active.2228de262a4851454006994fdfdab7b3.svg";
export { ForwardRef as ReactComponent };